import { Main } from '../presentational/Main';

export const MainContainer = () => {
    return <Main />;
};
